import request from '@/utils/request';
// 获取公司设置
export const getCompanySet = (params: any) =>
  request({
    url: 'System/companySet',
    method: 'GET',
    params
  });

// 修改公司信息
export const modifyCompany = (data: any) =>
  request({
    url: 'System/company',
    method: 'PUT',
    data
  });
// xiugai个性化设置
export const modifyCompanySet = (data: any) =>
  request({
    url: 'System/companySet',
    method: 'POST',
    data
  });
  // 自定义电子订单
export const getDiyEorder = (params: any) =>
  request({
    url: 'System/getDiyEorder',
    method: 'GET',
    params
  });

// 巡检电子工单 模板设置
export const getEorderTemplateSet = (params: any) =>
  request({
    url: 'System/eorderTemplateSet',
    method: 'GET',
    params
  });
export const eorderTemplateSet = (data: any) =>
  request({
    url: 'System/eorderTemplateSet',
    method: 'POST',
    data
  });

export const getMessageList = (params: any) =>
  request({
    url: 'Message/messageList',
    method: 'get',
    params
  });

export const readMessage = (data: any) =>
  request({
    url: 'Message/message',
    method: 'put',
    data
  });

export const deleteMessage = (data: any) =>
  request({
    url: 'Message/message',
    method: 'delete',
    data
  });

export const getNoticeList = (params: any) =>
  request({
    url: 'User/notice',
    method: 'get',
    params
  });

export const readNotice = (data: any) =>
  request({
    url: 'User/notice',
    method: 'post',
    data
  });
// System/companyModule 获取模块
export const getCompanyModule = (params: any) =>
  request({
    url: 'System/companyModule',
    method: 'get',
    params
  });
// System/companyModule 保存
export const saveCompanyModule = (data: any) =>
  request({
    url: 'System/companyModule',
    method: 'PUT',
    data
  });

// 巡检个性化设置
export const saveOrderPollingDiyData = (data: any) =>
  request({
    url: 'System/orderPollingDiyData',
    method: 'PUT',
    data
  });

// // 东改 微信公众号 配置
// export const getWechatConfig = (params: any) =>
//   request({
//     url: 'System/wxConfig',
//     method: 'get',
//     params
//   });
// export const configWechat = (data: any) =>
//   request({
//     url: 'System/wxConfig',
//     method: 'PUT',
//     data
//   });

// // 钉钉配置
// export const getDingdingConfig = (params: any) =>
//   request({
//     url: 'System/ddConfig',
//     method: 'get',
//     params
//   });

// export const configDingding = (data: any) =>
//   request({
//     url: 'System/ddConfig',
//     method: 'PUT',
//     data
//   });
export const getSmsList = (params: any) =>
  request({
    url: 'System/smsList',
    method: 'get',
    params
  });

export const timeoutUserLists = (params: any) =>
  request({
    url: 'System/timeoutUserLists',
    method: 'get',
    params
  });

export const timeoutUser = (data: any) =>
  request({
    url: 'System/timeoutUser',
    method: 'POST',
    data
  });
// 自定义报修模板设置详情
export const getRepairTemplate = (params: any) =>
  request({
    url: 'System/repairTemplate',
    method: 'get',
    params
  });
// 修改自定义报修模板
export const setRepairTemplate = (data: any) =>
  request({
    url: 'System/repairTemplate',
    method: 'POST',
    data
  });
  // 报修设置文案
export const getRepairPrompt = (params: any) =>
  request({
    url: 'System/repairPrompt',
    method: 'get',
    params
  });
export const setRepairPrompt = (data: any) =>
  request({
    url: 'System/repairPrompt',
    method: 'POST',
    data
  });
